import { ReactNode } from "react";
import { useFeatureToggle } from "../../hooks/ft.hooks";
import { FEATURES } from "../../app.config";

export function FeatureToggle({ feature, children }: { feature: keyof typeof FEATURES; children: ReactNode }) {
  const useFeature = useFeatureToggle(feature);
  if (useFeature) return <>{children}</>;
  return null;
}
